import { Experiment, User } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useIsMtoCrossNetworkUser } from '@ms/yammer-hooks/dist/users';

import { UseUIFeatureCheck } from '../types';

export { useIsCurrentUser, useIsCurrentUserAdmin } from '@ms/yammer-hooks/dist/users';
export { useIsLeader } from '@ms/yammer-hooks/dist/userHeaders';

export { useCanCurrentUserAccessEnhancedUserProfile } from '@ms/yammer-hooks/dist/userProfile';

export const useIsBookmarkThreadEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.BookmarkThread) === 'enabled';

export const useIsUserAchievementsEnabled: UseUIFeatureCheck = () => {
  const isNetworkQuestionsEnabledInGA = useExperimentTreatmentWithoutReporting(Experiment.AnswersInVivaGA) === true;

  return isNetworkQuestionsEnabledInGA;
};

export const useIsScheduledPostEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.ScheduledPosts) === true;

export const useIsMtoCrossNetworkUserProfile: UseUIFeatureCheck<[userId: User['id']]> = (userId) =>
  useIsMtoCrossNetworkUser(userId);
